import React, { PureComponent } from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles as pdfStyles, styles } from 'app/components/panels/inp/pdf/PdfDocument';
import { WeatherEvent } from 'app/model/SOL49';
import TimePeriodUtils from 'app/common/util/TimePeriodUtils';

export class Milex extends PureComponent<{ events: WeatherEvent[] }> {
    render() {
        const parser = new DOMParser();
        return (
            <View>
                <Text style={styles.section_title}>MILEX</Text>
                {this.props.events.map(event => {
                    const document = parser.parseFromString(event.description, 'text/html');
                    return (
                        <View key={event.id} style={{ paddingBottom: 10, paddingLeft: 5 }}>
                            <Text style={pdfStyles.h3_underlined}>{event.title}</Text>
                            <Text>
                                Location: ${event.refLocs.map(refLoc => `${refLoc.refId}/${refLoc.refType}`).join(',')}
                            </Text>
                            <Text style={{ paddingBottom: 5 }}>
                                Validity: {TimePeriodUtils.formatDateHHMM(event.validity)}
                            </Text>
                            <Text style={{ lineHeight: 1.5, paddingLeft: 10 }}>{document.body.innerText}</Text>
                        </View>
                    );
                })}
            </View>
        );
    }
}
